import React, { useState, useEffect } from "react";
import { Table, Button, Pagination, message } from "antd";
import ProductDetail from "../pages/ProductDetail";
import CreateProductModal from "../pages/CreateProductModal";
import { subItemHooks } from "../hooks";
const ProductLayout = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false);
  const [isCreateModalVisible, setIsCreateModalVisible] = useState(false);

  const fetchProducts = async (currentPage = 1) => {
    setLoading(true);
    try {
      const response = await subItemHooks.productList({ page: currentPage });
      const { data, cnt } = response.data;
      setProducts(data);
      setTotal(cnt);
    } catch (error) {
      console.error("상품 데이터를 가져오는 중 오류가 발생했습니다.", error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await subItemHooks.productDelete({ id: id });
      if (res.IsError) {
        throw new Error("delete banner error");
      }
      message.success("상품이 삭제되었습니다.");
      fetchProducts(page);
      setIsDetailModalVisible(false);
    } catch (error) {
      console.error("상품 삭제 중 오류가 발생했습니다.", error);
      message.error("상품 삭제에 실패했습니다.");
    }
  };

  const handleUpdate = async (updatedData) => {
    try {
      console.log("handling data", updatedData);
      const res = await subItemHooks.productUpdate({
        brandName: updatedData.brand_name,
        contentId: "",
        exposure: updatedData.exposure,
        id: updatedData.id,
        productLink: updatedData.product_link,
        productPrice: updatedData.product_price,
        productThumbnail: updatedData.product_thumbnail,
        productTitle: updatedData.product_title,
      });

      if (res.IsError) {
        throw new Error("update banner error");
      }
      message.success("상품이 수정되었습니다.");
      fetchProducts(page);
      setIsDetailModalVisible(false);
    } catch (error) {
      console.error("상품 수정 중 오류가 발생했습니다.", error);
      message.error("상품 수정에 실패했습니다.");
    }
  };

  const handleCreate = async (newProduct) => {
    try {
      const res = await subItemHooks.productCreate({
        brandName: newProduct.brand_name,
        contentId: "",
        productLink: newProduct.product_link,
        productPrice: newProduct.product_price,
        productThumbnail: newProduct.product_thumbnail.split(",")[1],
        productTitle: newProduct.product_title,
      });
      if (res.IsError) {
        throw new Error("create banner error");
      }
      message.success("새 상품이 생성되었습니다.");
      fetchProducts(page);
      setIsCreateModalVisible(false);
    } catch (error) {
      console.error("상품 생성 중 오류가 발생했습니다.", error);
      message.error("상품 생성에 실패했습니다.");
    }
  };

  useEffect(() => {
    fetchProducts(page);
  }, [page]);

  const columns = [
    {
      title: "브랜드",
      dataIndex: "brand_name",
    },
    {
      title: "제품명",
      dataIndex: "product_title",
    },
    {
      title: "가격",
      dataIndex: "product_price",
    },
    {
      title: "제품 링크",
      dataIndex: "product_link",
      render: (link) => (
        <a href={link} target="_blank" rel="noopener noreferrer">
          {link}
        </a>
      ),
    },
    {
      title: "썸네일",
      dataIndex: "product_thumbnail",
      render: (url) => (
        <img
          src={url}
          alt="썸네일"
          style={{ width: 100, height: 50, objectFit: "cover" }}
        />
      ),
    },
    {
      title: "상품 노출",
      dataIndex: "exposure",
      render: (value) => (value ? "노출" : "숨김"),
    },
    {
      title: "판매중지 여부",
      dataIndex: "is_del",
      render: (value) => (value ? "판매 중지" : "판매 중"),
    },
    {
      title: "상세보기",
      render: (record) => (
        <Button
          type="link"
          onClick={() => {
            setSelectedProduct(record);
            setIsDetailModalVisible(true);
          }}
        >
          상세 보기
        </Button>
      ),
    },
  ];

  return (
    <div>
      <div
        style={{
          marginBottom: "20px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button type="primary" onClick={() => setIsCreateModalVisible(true)}>
          상품 생성하기
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={products}
        rowKey="id"
        pagination={false}
        loading={loading}
      />
      <Pagination
        current={page}
        total={total}
        pageSize={10}
        onChange={(page) => setPage(page)}
        style={{ marginTop: 20, textAlign: "center" }}
      />
      {isDetailModalVisible && selectedProduct && (
        <ProductDetail
          visible={isDetailModalVisible}
          onClose={() => setIsDetailModalVisible(false)}
          product={selectedProduct}
          onDelete={handleDelete}
          onUpdate={handleUpdate}
        />
      )}
      {isCreateModalVisible && (
        <CreateProductModal
          visible={isCreateModalVisible}
          onClose={() => setIsCreateModalVisible(false)}
          onCreate={handleCreate}
        />
      )}
    </div>
  );
};

export default ProductLayout;
